import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import defaultRoutes from './_default';
import authRoutes from './_auth';
import managementRoutes from './_management';
import damagecasesRoutes from './_damagecases';
import damageassessorRoutes from './_damageassessor';
import userManagment from './_usermanagment';
import rentalCars from './_rentalcars';
import appsEmployee from './_apps_employee';
import statistics from './_statistics';
import vehicles from './_vehicles';
import repairshop from './_repairshop';
import companychildren from './_managecompanychildren';
import brokerRoutes from './_brokercases';
import invitationRoutes from './_invitations';
import premiumpartnersRoutes from './_premiumpartners';

import store from '../store/';

const routes: Array<RouteConfig> = [
	...defaultRoutes,
	...authRoutes,
	...managementRoutes,
	...damagecasesRoutes,
	...damageassessorRoutes,
	...userManagment,
	...rentalCars,
	...appsEmployee,
	...statistics,
	...vehicles,
	...repairshop,
	...companychildren,
	...brokerRoutes,
	...invitationRoutes,
	...premiumpartnersRoutes,
];

Vue.use(VueRouter);

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes,
	scrollBehavior(to, from, savedPosition) {
		if (to?.meta?.disableScroll || from?.meta?.disableScroll) return;
		if (savedPosition) {
			return savedPosition;
		} else {
			return { x: 0, y: 0 };
		}
	},
});

async function onBeforeEach(to, from, next) {
	const isUserAuthorized = await store.dispatch('isAuthorized');
	const isGuestRoute = to.matched.some(record => record.meta.guest);
	const isEmployeeAppRoute = to.matched.some(record => record.meta.mitarbeiterapp);
	const levelGuard = to.meta.levelGuard;
	const isUserPassLevelGuard = levelGuard ? levelGuard.find(level => level == store.getters.getAuthenticatedUserGroupLevel) : false;
	const isRouteAllowed = isUserAuthorized || isGuestRoute;

	store.commit('addHistory', from);

	if (to.name === 'ManagePayment') {
		return next();
	}

	if (isEmployeeAppRoute) {
		if (store.getters.getAppsEmployeeLoginStatus && isGuestRoute) {
			next({ name: 'AppsEmployeeMain' });
		} else if ((!store.getters.getAppsEmployeeLoginStatus && isGuestRoute) || store.getters.getAppsEmployeeLoginStatus) {
			next();
		} else {
			next({ name: 'AppsEmployeeLogin' });
		}
	} else if (isRouteAllowed) {
		if ((levelGuard && isUserPassLevelGuard) || !levelGuard) {
			const confirmLeaving = store.getters.getConfirmLeaving;
			const isMuteConfirmLeaving = store.getters.getIsMuteConfirmLeaving;
			if (confirmLeaving !== false && isMuteConfirmLeaving === false) {
				const check = confirm(confirmLeaving);
				if (check) {
					store.commit('setConfirmLeaving', false);
					next();
				}
			} else {
				if (store.getters.getAuthenticatedUserGroupLevel == 5 || store.getters.getAuthenticatedUserGroupLevel == 6) {
					if (!store.getters.getUser.stripePaymentStored && to.name != 'login' && to.name != 'BlobViewer') {
						if (store.getters.isLevelAdmin) {
							next({ name: 'ManagePayment' });
						} else {
							await store.dispatch('logout');
							next({ name: 'login' });
						}
					} else {
						next();
					}
				} else {
					next();
				}
			}
		} else {
			next({ name: 'PageNotFound' });
		}
	} else {
		next({ name: 'login' });
	}
}

router.beforeEach(onBeforeEach);

export default router;
